import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const usersService = {
    async list(query = {}) {
        const { data } = await api.get("/users", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/users/${id}`);
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/users", payload);
        return data;
    },
    async update(id, payload) {
        const { data } = await api.patch(`/users/${id}`, payload);
        return data;
    },
    async remove(id) {
        await api.delete(`/users/${id}`);
    },
};
